import React, { useState, useEffect } from 'react'
import styled from '@emotion/styled'

import GoButton from './GoButton'
import Textbox from '../../generic/floatingText'
import Dropdown from '../../generic/floatingDropdown'
import { FlexRowDiv } from '../../generic/Basics'
import { fontSize3XSmall, white, fontSize2XSmall, fontWeightSemibold, fontFamilyOpenSans } from '../../../constants/principles'
import Error from '../../generic/Error'
import { breakpoints } from '../../../constants'

export default ({ globalState, states, onChange, error, displayYMM, showMakeModelTab, onClick, trims = [], argoButtonEnabled, updateGlobalState }) => {
  const [localError, setLocalError] = useState(false)
  const [isClicked, setClicked] = useState(false)
  const isLoading = trims.length === 0 && isClicked && !localError && !error && (!displayYMM || showMakeModelTab)
  const onChangeLocal = (...e) => {
    onChange(...e)
    setLocalError(false)
    setClicked(false)
  }
  const onClickNew = e => {
    onClick(e, false, 'License Plate', !(globalState.plate && globalState.state))
    setLocalError(!(globalState.plate && globalState.state))
    setClicked(true)
  }

  const onClickInput = e => {
    updateGlobalState({ isIneligibleYear: false, fireAnalytics: 'first_trade_in_start' })
  }

  useEffect(() => {
    const handleUp = event => {
      if (event.target.id !== 'license-plate-entry') {
        return
      }
      const { keyCode } = event

      if (keyCode === 9) {
        updateGlobalState({ isIneligibleYear: false, fireAnalytics: 'first_trade_in_start' })
      }
    }

    window.addEventListener('keyup', handleUp)
    return () => window.removeEventListener('keyup', handleUp)
  }, [updateGlobalState])

  return (
    <>
      <StyledContainer>
        <StyledTextDiv>
          <Textbox
            maskData={true}
            backgroundColor={white}
            onChange={newValue => onChangeLocal({ plate: newValue }, 1)}
            value={globalState.plate || ''}
            fullWidth={true}
            label="License Plate"
            maxLength={10}
            placeholder="License Plate"
            isError={!globalState.plate && error}
            autoFocus={true}
            id={'license-plate-entry'}
            testId="bi-tb-license-plate-entry"
            onClick={onClickInput}
          />
        </StyledTextDiv>
        <StyledStateDiv>
          <Dropdown
            id="state-entry"
            testId="bi-dd-state-entry"
            backgroundColor={white}
            fullWidth={true}
            label="State"
            options={states}
            onChange={e => onChangeLocal({ state: e.target.value }, 1)}
            currentValue={globalState.state || 'Select'}
            isError={!globalState.state && error}
            onClick={onClickInput}
          />
        </StyledStateDiv>
        <StyledButtonDiv>
          <GoButton isLoading={isLoading} onClick={e => onClickNew(e)} argo={argoButtonEnabled} />
        </StyledButtonDiv>
      </StyledContainer>
      {!error && !localError && displayYMM && <InstructionDiv>{`Please enter your License Plate or select your vehicle's information below.`}</InstructionDiv>}
      {(error || localError) && (
        <FullWidthDiv>
          <Error
            text={(globalState.plate && globalState.state) || displayYMM ? `We couldn't find that License Plate. Please re-enter it${displayYMM ? " or select your vehicle's information below" : ''}.` : 'Enter your License Plate and State.'}
            id={'vin-error'}
            testId={'bi-lb-vin-error'}
            isError={true}
            leftAlign={true}
          />
        </FullWidthDiv>
      )}
      {!displayYMM && (
        <StyledSpan>
          We only need your license plate to look
          <br />
          up your car. It will not be stored.
        </StyledSpan>
      )}
    </>
  )
}

const StyledContainer = styled(FlexRowDiv)`
  width: 100%;
  align-items: unset;
`
const StyledSpan = styled.span`
  width: 100%;
  padding-top: 8px;
  font-size: ${fontSize3XSmall};
  text-align: center;
`
const StyledTextDiv = styled.div`
  width: 45%;
  margin-right: 0px;
  @media (min-width: ${breakpoints.sm}px) {
    margin-right: 8px;
  }
`
const FullWidthDiv = styled.div`
  width: 100%;
`

const InstructionDiv = styled(FullWidthDiv)`
  font-size: ${fontSize2XSmall};
  font-weight: ${fontWeightSemibold};
  font-family: ${fontFamilyOpenSans};
  padding-top: 8px;
`
const StyledStateDiv = styled.div`
  width: 100px;
  margin: 0 8px;
`
const StyledButtonDiv = styled.div`
  display: flex;
  flex-wrap: wrap;
  line-height: 26px;
  border-radius: 6px;
`
